import { useContext } from 'react';
import { useConfiguration } from '~/context/common/StaticContext';
import TradeContext, {
  useGetTradeInStatus
} from '~/context/common/TradeContext';
import useGetIsInTaxSavingRestrictedState from './useGetIsInTaxSavingRestrictedState';

export default function useShowTradeIncentives() {
  const { shouldShowWSYS = false } = useConfiguration();
  const { selectedTrade } = useContext(TradeContext);
  const { maxTradeTaxSavings, tradeIncentive } = selectedTrade ?? {};
  const { isPending } = useGetTradeInStatus();
  const isSavingsOnly = Boolean(maxTradeTaxSavings && !tradeIncentive);
  const isInRestrictedState = useGetIsInTaxSavingRestrictedState();

  const hasExperimentValues = Boolean(maxTradeTaxSavings || tradeIncentive);
  const canShowSavingsOnly = !(isInRestrictedState && isSavingsOnly);

  return (
    shouldShowWSYS && hasExperimentValues && !isPending && canShowSavingsOnly
  );
}
